'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MediaIcon = require('./MediaIcon');

var _MediaIcon2 = _interopRequireDefault(_MediaIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MediaIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/MediaIcon/index.js
// module id = 605
// module chunks = 11